/**
 * Code for social/landing pages
 */

module.exports = function LandingPage() {
    $('.js-charity-info').on('click', function(e) {
        var link = $(e.currentTarget);
        var modal = $(link).data('bsTarget');

        var charityId = $(link).parent().data('charity-id');
        var charityName = $(link).parent().data('charity-name');
        var charityDesc = $(link).parent().data('charity-desc');
        var charityImage = $(link).parent().data('charity-img');

        $(modal).find(".js-charity-info-name").html(charityName);
        $(modal).find(".js-charity-info-desc").html(charityDesc.replace('\\n','<br><br>'));
        $(modal).find(".js-charity-info-img").attr('src',charityImage);
        $(modal).find(".js-charity-info-btn").attr('href','/join?cid=' + charityId);
    });
}